import * as craft from '~/services/craft'
export default ({ }, inject) -> inject 'craft', craft
